<template>
  <DropdownItem :click-fn="onLanguageClick" :label="option.value" />
</template>

<script>
import DropdownItem from '@/modules/core/app/components/DropdownItem.vue';
import Enum from '@/modules/core/app/helpers/Enum';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'LanguageDropDownItem',
  emits: ['on-language-click'],
  components: { DropdownItem },
  props: {
    option: { type: Enum, required: true }
  },
  methods: {
    onLanguageClick() {
      this.$emit('on-language-click', this.option);
    }
  }
};
</script>
